export default function LoadingSpinner({ message = 'Loading…', size = 'large' }) {
  const spinnerSize = size === 'large' ? 'w-16 h-16 border-4' : 'w-8 h-8 border-2';
  const textSize = size === 'large' ? 'text-2xl' : 'text-lg';
  
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4">
      <div className={`${spinnerSize} border-indigo-600 border-t-transparent rounded-full animate-spin`}></div>
      {message && (
        <p className={`${textSize} text-slate-500 dark:text-slate-400`}>{message}</p>
      )}
    </div>
  );
}
